import { Services } from '@sigma-frontend-libs/commons'

import entity from '@/components/entity'
import divider from '@/components/g/divider'
import preloader from '@/components/preloader'
import { serviceNameKebabCase } from '@/components/services/report-manager/queue/utils'

function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [
        h(
          preloader,
          {
            props: {
              size: 10
            }
          }
        )
      ]
    )
  }
}

function renderTitle(h) {
  return h(
    'span',
    {},
    [ this.getTranslate(`${Services['report-manager']}.labels.filterBy`) ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__subheader`
    },
    [
      renderTitle.call(this, h),
      h(divider),
      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderContent(h) {
  return h(
    entity,
    {
      props: {
        value: this.items,
        fields: Object.keys(this.items),
        pathToLabels: `${Services['report-manager']}.labels.${this.value.type}`,
        service: Services['report-manager']
      }
    }
  )
}

export default function(h) {
  if (this.hasItems) {
    return h(
      'div',
      {
        class: `${serviceNameKebabCase}-form-readonly__section`
      },
      [
        renderHeader.call(this, h),
        renderContent.call(this, h)
      ]
    )
  }
}
